import { FormEvent, useState } from "react";
import { Alert, Button, Card, Form, Stack } from "react-bootstrap";

export interface LoginCardProps {
  onSubmit: (email: string, password: string) => Promise<void>;
}

const LoginCard = ({ onSubmit }: LoginCardProps) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState<string>();

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setError(undefined);
    setSubmitting(true);

    try {
      await onSubmit(email.trim(), password);
    } catch (submissionError) {
      if (submissionError instanceof Error) {
        setError(submissionError.message);
      } else {
        setError("Unable to sign in. Please try again.");
      }
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Card className="shadow-sm auth-card">
      <Card.Body>
        <div className="mb-4">
          <Card.Title className="text-center mb-2">
            Restricted platform access
          </Card.Title>
          <Card.Subtitle className="text-center text-muted">
            Only whitelisted ops users can upload Android builds.
          </Card.Subtitle>
        </div>

        {error ? (
          <Alert variant="danger" className="small">
            {error}
          </Alert>
        ) : null}

        <Form onSubmit={handleSubmit}>
          <Stack gap={3}>
            <Form.Group controlId="email">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                value={email}
                placeholder="you@wholesale.com"
                autoComplete="email"
                onChange={(event) => setEmail(event.target.value)}
                required
              />
            </Form.Group>

            <Form.Group controlId="password">
              <Form.Label>Password</Form.Label>
              <Form.Control
                type="password"
                value={password}
                placeholder="Enter password"
                autoComplete="current-password"
                onChange={(event) => setPassword(event.target.value)}
                required
              />
            </Form.Group>

            <Button
              type="submit"
              variant="primary"
              className="w-100"
              disabled={submitting}
            >
              {submitting ? "Signing in..." : "Sign in"}
            </Button>
          </Stack>
        </Form>
      </Card.Body>
    </Card>
  );
};

export default LoginCard;
